module.exports = __webpack_public_path__ + "img/add_black_icon.5a32db2d.svg";